import React, { useState, useEffect } from "react";
// import logo from "../../images/header/carLogo.png";
import logo from "../../images/header/carzenHlogo.png";

import { useLocation, useNavigate } from "react-router-dom";
export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  // const toggleMenu = () => setMenuOpen(!menuOpen);
  const location = useLocation();
  const navigate = useNavigate();

  //   const moveToContact = () => {
  //     const section = document.getElementById("contact");
  //     section?.scrollIntoView({ behavior: "smooth" });
  //   };

  const moveToSection = (id) => {
    if (id === "home") {
      // Go to ABOUT page
      navigate("/", { state: { scrollTo: id } });

      return;
    }
    if (id === "contact us") {
      // Go to ABOUT page
      navigate("/", { state: { scrollTo: id } });

      return;
    }
    if (id === "about") {
      // Go to ABOUT page
      navigate("/about_us", { state: { scrollTo: id } });
      return;
    }
    if (id === "services") {
      // Go to ABOUT page
      navigate("/", { state: { scrollTo: id } });

      return;
    }
    if (id === "prices") {
      // Go to ABOUT page
      navigate("/", { state: { scrollTo: id } });

      return;
    }

    // if (location.pathname !== "/") {
    //   // Go to home page *with state*
    //   navigate("/", { state: { scrollTo: id } });
    // }
    //  else if (location.pathname !== "/about") {
    //   navigate("/about", { state: { scrollTo: id } });
    // }
    else {
      // Already on home → scroll immediately
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  // useEffect(() => {
  //   if (location.state?.scrollTo) {
  //     const id = location.state.scrollTo;
  //     const element = document.getElementById(id);

  //     setTimeout(() => {
  //       element?.scrollIntoView({ behavior: "smooth", block: "start" });
  //     }, 200);
  //   }
  // }, []);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!location.state?.scrollTo) return;

    const id = location.state.scrollTo;

    const element = document.getElementById(id);
    if (!element) return;

    setTimeout(() => {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);

    navigate(location.pathname, { replace: true, state: {} });
    // eslint-disable-next-line
  }, [location.key]);

  //   const moveToSection = (id) => {
  //     if (id === "services") {
  //       console.log("id:", id);
  //       // Go to ABOUT page
  //       Navigate("/", { state: { scrollTo: id } });
  //       return;
  //     }

  //     if (location.pathname !== "/") {
  //       // Go to home page *with state*
  //       Navigate("/", { state: { scrollTo: id } });
  //     }
  //     //  else if (location.pathname !== "/about") {
  //     //   navigate("/about", { state: { scrollTo: id } });
  //     // }
  //     else {
  //       // Already on home → scroll immediately
  //       const element = document.getElementById(id);
  //       if (element) {
  //         element.scrollIntoView({ behavior: "smooth" });
  //       }
  //     }
  //   };
  return (
    <nav className="relative z-20 w-full ">
      <div className="max-w-8xl mx-auto  py-3  md:py-[30px]  flex justify-between content-center items-center">
        <div
          className="ml-0 md:mr-4 scale-110 "
          onClick={() => moveToSection("home")}
        >
          <img
            src={logo}
            className="w-auto lg:ml-2 h-[40px] md:w-[120px] md:h-[30px] lg:w-auto lg:h-[43px] object-contain"
            alt="carzen logo"
          />
          {/* cargenLogistics */}
        </div>
        <ul className="hidden md:flex space-x-7  md:text-[12px] lg:text-[18px] items-center">
          <li className="cursor-pointer" onClick={() => moveToSection("home")}>
            <p className="hover:text-gray-300">Home</p>
          </li>
          <li
            className="cursor-pointer"
            onClick={() => moveToSection("services")}
          >
            <p className="hover:text-gray-300">Services</p>
          </li>
          <li className="cursor-pointer" onClick={() => moveToSection("about")}>
            <p className="hover:text-gray-300">About</p>
          </li>
          <li
            className="cursor-pointer"
            onClick={() => moveToSection("prices")}
          >
            <p className="hover:text-gray-300">Prices</p>
          </li>
          <li
            className="cursor-pointer"
            onClick={() => moveToSection("contact us")}
          >
            <p className="hover:text-gray-300">Contact Us</p>
          </li>
          <li className="cursor-pointer">
            <button
              onClick={() => moveToSection("contact us")}
              className="bg-[#CCA065]

                text-white font-medium py-2 md:px-4 lg:px-6 rounded-md shadow-lg transition duration-300"
            >
              Book Now
            </button>
          </li>
        </ul>
        {/* Mobile Menu Icon */}
        {/* <button className="md:hidden focus:outline-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              />
            </svg>
          </button> */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen((s) => !s)}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            className="focus:outline-none"
          >
            {/* When you want a morphing hamburger <-> X you can replace these SVGs with the animated pair */}
            {!menuOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            )}
          </button>
        </div>
      </div>
      {/* 🔹 Mobile Menu Button */}

      {/* 🔹 Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-white rounded-b-lg shadow-md md:hidden mt-1 py-4 z-40">
          <ul className="flex flex-col items-center space-y-4 text-[16px] md:text-lg font-medium">
            {["Home", "Services", "About", "Prices", "Contact Us"].map(
              (item) => (
                <li
                  key={item}
                  className="text-black cursor-pointer transition"
                  onClick={() => {
                    moveToSection(item.toLowerCase());
                    setMenuOpen(false);
                  }}
                >
                  {item}
                </li>
              )
            )}
            <li className="cursor-pointer">
              <button
                onClick={() => moveToSection("contact us")}
                className="bg-[#CCA065]

                text-white font-medium py-2 px-6 rounded-md transition shadow-lg duration-300"
              >
                Book Now
              </button>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
